import { ReactNode, useState } from 'react'

import { FormGroup, Radio, RadioItem, Text, defaultTheme } from '@agro-club/agroclub-shared'
import { isUS } from 'env'
import { BidKind, USBidContractType } from 'modules/domain/bid/types'
import { User } from 'modules/domain/user/types'
import { useTranslation } from 'react-i18next'
import { useMediaQuery } from 'react-responsive'
import { AMobileModal } from 'views/components/MobileComponents/Modal/AMobileModal'
import { SharedModalTitle } from 'views/components/SharedModal'
import ASharedModal from 'views/components/SharedModal/ASharedModal'
import { USAddBidModal } from 'views/pages/Bid/BidModals/Bid/USModals/USAddBidModal'
import { FormItemWrapper } from 'views/styled/common'
import { AnalyticsPlaces } from '../analyticsPlaces'
import { BidAddForm } from './Bid/BidAddForm'
import { PotentialBidAddForm } from './PotentialBid/PotentialBidAddForm'

export const InitialMainParameter = {
  parameter: undefined,
  parameter_value_from: undefined,
  parameter_value_to: undefined,
}

type Props = {
  companyId?: string
  user?: User
  productId?: string
  symbol?: string
  onClose: () => void
  onSuccess?: (value) => void
  formTitle?: ReactNode
}

export const availableBidKinds = isUS
  ? [BidKind.basis, BidKind.cash_priced, BidKind.potential]
  : [BidKind.regular, BidKind.potential]

export const BidCreateModal = ({ user, productId, symbol, onClose, onSuccess, formTitle, companyId }: Props) => {
  const { t } = useTranslation('bid')
  const [bidKind, setBidKind] = useState<BidKind>(availableBidKinds[0])

  const isMobile = useMediaQuery({
    query: `(max-width: ${defaultTheme.queries.mobile})`,
  })

  const bidKindJSX = (
    <FormGroup label={t('form.bidType')}>
      <FormItemWrapper>
        <Radio
          value={bidKind}
          onChange={(value) => {
            setBidKind(value as BidKind)
          }}
        >
          {availableBidKinds.map((v) => (
            <RadioItem key={v} value={v} label={t(`kind.${v}`)} />
          ))}
        </Radio>
      </FormItemWrapper>
    </FormGroup>
  )

  let form
  if (bidKind == BidKind.potential) {
    form = (
      <PotentialBidAddForm user={user} onClose={onClose}>
        {bidKindJSX}
      </PotentialBidAddForm>
    )
  } else if (bidKind in USBidContractType) {
    form = (
      <USAddBidModal
        companyId={companyId}
        user={user}
        productId={productId}
        symbol={symbol}
        onClose={onClose}
        onSuccess={onSuccess}
        contractType={bidKind as unknown as USBidContractType}
      >
        {bidKindJSX}
      </USAddBidModal>
    )
  } else {
    form = (
      <BidAddForm user={user} onClose={onClose} bidKind={bidKind as BidKind} onSuccess={onSuccess}>
        {bidKindJSX}
      </BidAddForm>
    )
  }

  return (
    <>
      {isMobile ? (
        <AMobileModal
          header={<Text typography="titleH4">{formTitle || t('form.add')}</Text>}
          id={AnalyticsPlaces.CREATE_MODAL}
          onClose={onClose}
        >
          {form}
        </AMobileModal>
      ) : (
        <ASharedModal onClose={onClose} size="medium" id={AnalyticsPlaces.CREATE_MODAL}>
          <SharedModalTitle>{formTitle || t('form.add')}</SharedModalTitle>
          {form}
        </ASharedModal>
      )}
    </>
  )
}
